<template>
  <div>
    <va-notification
      :value="!!showError.length"
      color="danger"
      class="mb-4"
    >
      {{ showError[0] }}
    </va-notification>

    <va-card>
      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        :totalPages="totalPages"
        @page-selected="readItems"
        no-data-label="Nenhum serviço encontrado"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-button
            flat
            small
            color="gray"
            @click="edit(props.rowData)"
            class="ma-0"
          >
            {{ $t("tables.edit") }}
          </va-button>

          <va-button
            flat
            small
            color="danger"
            @click="remove(props.rowData)"
            class="ma-0"
          >
            {{ $t("tables.delete") }}
          </va-button>
        </template>
      </va-data-table>
    </va-card>

    <va-modal
      v-model="showConfirmModal"
      size="small"
      title="Atenção"
      :message="`Você tem certeza que deseja remover o serviço ${selectedService.name}?`"
      :okText=" $t('modal.confirm') "
      :cancelText=" $t('modal.cancel') "
      @ok="handleDelete"
    />
  </div>
</template>

<script>
// import axios from 'axios'
import api from '../api'

export default {
  data () {
    return {
      perPage: 10,
      totalPages: 0,
      items: [],
      loading: false,
      selectedService: {},
      showConfirmModal: false,
      showError: [],
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'name',
          title: this.$t('tables.headings.name'),
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        },
      ]
    },
  },
  created () {
    this.readItems()
  },
  methods: {
    readItems (page = 0) {
      if (page > 0) {
        page -= 1;
      }
      
      this.loading = true

      // HERE FETCH serviços
      api.get(`/service?page=${page}&size=${this.perPage}`)
        .then(response => {
          this.items = response.data.content
          this.totalPages = response.data.totalPages
        })
        .catch(err => {
          console.log(err.message)
          this.showError = ['Houve um problema em listar as categorias. Por favor, tente novamente.']

          setTimeout(() => {
            this.showError = []
          }, 3000)
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit (servico) {
      this.$router.push({ name: 'edit-service', params: { id: servico.id } })
    },
    remove (servico) {
      this.showConfirmModal = true
      this.selectedService = servico
    },
    handleDelete () {
      api.delete(`/service/${this.selectedService.id}`)
        .then(res => {
          this.showToast('Serviço removido com sucesso')

          const idx = this.items.findIndex((u) => u.id === this.selectedService.id)
          this.items.splice(idx, 1)
        })
        .catch(err => {
          console.log(err.message)
          this.showError = ['Houve um problema em listar as categorias. Por favor, tente novamente.']

          setTimeout(() => {
            this.showError = []
          }, 3000)
        })
    },
  },
}
</script>

<style lang="scss">
.data-table-server-pagination---avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
